import { render } from "./UploadForm.vue?vue&type=template&id=324fd65c&scoped=true&ts=true&lang=pug"
import script from "./UploadForm.vue?vue&type=script&lang=ts"
export * from "./UploadForm.vue?vue&type=script&lang=ts"

import "./UploadForm.vue?vue&type=style&index=0&id=324fd65c&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324fd65c"]])

export default __exports__